import Encoding from 'encoding-japanese';

/**
 * This function is determined whether there is a eucjp string
 * Due to Backend not allowed ctrl character and some characters will be rejected by backend,
 * if input value contains those characters, it will be deemed to a unsupported string
 * @param value
 */
const unsupportedContainsValidation = function (value: string) {
    if (containsControlCharacter(value)) {
        return true;
    }

    if (containsJavaRejectCharacter(value)) {
        return true;
    }

    const innerValue = specialCharacterTransform(value);
    const res = Encoding.convert(innerValue, 'EUCJP', 'UNICODE');
    const unicodeString = Encoding.convert(res, 'UNICODE', 'EUCJP');
    if (unicodeString !== innerValue) {
        return true;
    }

    return false;
};

/**
 * Because of some characters unicode was rejected in backend(java),
 * This function is determined whether there is a character that rejected by java.
 * If have return true, otherwise return false
 * @param value
 */
export const containsJavaRejectCharacter = function (value: string) {
    const JAVA_REJECT_CHARACTERS = [
        '\u2015',
        '\u2121',
        '\u2160',
        '\u2161',
        '\u2162',
        '\u2163',
        '\u2164',
        '\u2165',
        '\u2166',
        '\u2167',
        '\u2168',
        '\u2169',
        '\u2170',
        '\uff07',
        '\u2171',
        '\u2172',
        '\u2173',
        '\u2174',
        '\u2175',
        '\u2176',
        '\u2177',
        '\u2178',
        '\u2179',
        '\u2211',
        '\u221f',
        '\u2225',
        '\u222e',
        '\u22bf',
        '\u2460',
        '\u2461',
        '\u2462',
        '\u2463',
        '\u2464',
        '\u2465',
        '\u2466',
        '\u2467',
        '\u2468',
        '\u2469',
        '\u246a',
        '\u246b',
        '\u246c',
        '\u246d',
        '\u246e',
        '\u246f',
        '\u2470',
        '\u2471',
        '\u2472',
        '\u2473',
        '\u301d',
        '\u301f',
        '\u3231',
        '\u3232',
        '\u3239',
        '\u32a4',
        '\u32a5',
        '\u32a6',
        '\u32a7',
        '\u32a8',
        '\u3303',
        '\u330d',
        '\u3314',
        '\u3318',
        '\u3322',
        '\u3323',
        '\u3326',
        '\u3327',
        '\u332b',
        '\u3336',
        '\u333b',
        '\u3349',
        '\u334a',
        '\u334d',
        '\u3351',
        '\u3357',
        '\u337b',
        '\u337c',
        '\u337d',
        '\u337e',
        '\u338e',
        '\u338f',
        '\u339c',
        '\u339d',
        '\u339e',
        '\u33a1',
        '\u33c4',
        '\u33cd',
        '\u4efc',
        '\u50f4',
        '\u51ec',
        '\u5307',
        '\u5324',
        '\u548a',
        '\u5759',
        '\u589e',
        '\u5bec',
        '\u5cf5',
        '\u5d53',
        '\u5fb7',
        '\u6085',
        '\u6120',
        '\u654e',
        '\u663b',
        '\u6665',
        '\u6801',
        '\u6a6b',
        '\u6ae2',
        '\u6df2',
        '\u6df8',
        '\u7028',
        '\u70bb',
        '\u7501',
        '\u7682',
        '\u769e',
        '\u7930',
        '\u7ae7',
        '\u7da0',
        '\u7dd6',
        '\u8362',
        '\u85b0',
        '\u8807',
        '\u8b7f',
        '\u8cf4',
        '\u8d76',
        '\u90de',
        '\u9115',
        '\u9592',
        '\u973b',
        '\u974d',
        '\u9751',
        '\u999e',
        '\u9ad9',
        '\u9b72',
        '\u9ed1',
        '\uf929',
        '\uf9dc',
        '\ufa0e',
        '\ufa0f',
        '\ufa10',
        '\ufa11',
        '\ufa12',
        '\ufa13',
        '\ufa14',
        '\ufa15',
        '\ufa16',
        '\ufa17',
        '\ufa18',
        '\ufa19',
        '\ufa1a',
        '\ufa1b',
        '\ufa1c',
        '\ufa1d',
        '\ufa1e',
        '\ufa1f',
        '\ufa20',
        '\ufa21',
        '\ufa22',
        '\ufa23',
        '\ufa24',
        '\ufa25',
        '\ufa26',
        '\ufa27',
        '\ufa28',
        '\ufa29',
        '\ufa2a',
        '\ufa2b',
        '\ufa2c',
        '\ufa2d',
        '\uff02',
        '\uff0d',
        '\uffe0',
        '\uffe1',
        '\uffe2',
        '\uffe4',
    ];
    return Array.from(value).some((char) => JAVA_REJECT_CHARACTERS.includes(char));
};

/**
 * This function is determined whether there is a character that contains control character.
 * If have return true, otherwise return false
 * @param value
 */
export const containsControlCharacter = function (value: string) {
    const CONTROL_CHARACTERS = [
        '\u0001',
        '\u0002',
        '\u0003',
        '\u0004',
        '\u0005',
        '\u0006',
        '\u0007',
        '\u0008',
        '\u000b',
        '\u000c',
        '\u000d',
        '\u000e',
        '\u000f',
        '\u0010',
        '\u0011',
        '\u0012',
        '\u0013',
        '\u0014',
        '\u0015',
        '\u0016',
        '\u0017',
        '\u0018',
        '\u0019',
        '\u001a',
        '\u001b',
        '\u001c',
        '\u001d',
        '\u001e',
        '\u001f',
    ];

    return Array.from(value).some((char) => CONTROL_CHARACTERS.includes(char));
};

/**
 * some character's unicode difference between windows and unix system.
 * In font-end, we use third party library(encoding-japanese) convert unicode to euc-jp
 * but encoding-japanese not support Unicode of Unix(except U+301C )
 * this function can convert Unicode(Unix) to Unicode(Windows)
 * character                        Unicode(Unix)   Unicode(Windows)
 * ～(WAVE DASH)                        U+301C          U+FF5E
 * －(FULLWIDTH MINUS SIGN)             U+2212          U+FF0D
 * ￠(CENT SIGN)                        U+00A2          U+FFE0
 * ￡(POUND SIGN)                       U+00A3          U+FFE1
 * ￢(NOT SIGN)                         U+00AC          U+FFE2
 * ―(HORIZONTAL BAR)                    U+2014          U+2015
 * ∥(DOUBLE VERTICAL LINE)              U+2016          U+2225
 *
 * @param value
 */
export const specialCharacterTransform = function (value: string) {
    const SPECIAL_CHARACTER_MAP = new Map([
        [0x2014, '\u2015'],
        [0x301c, '\uff5e'],
        [0x2016, '\u2225'],
        [0x2212, '\uff0d'],
        [0x00a2, '\uffe0'],
        [0x00a3, '\uffe1'],
        [0x00ac, '\uffe2'],
    ]);
    const res = Array.from(value)
        .map((e) => {
            const key = e.charCodeAt(0);
            const val = SPECIAL_CHARACTER_MAP.get(key);
            return val ?? e;
        })
        .join('');
    return res;
};

export const specialCharacterTransformReverse = function (value: string) {
    const SPECIAL_CHARACTER_MAP = new Map([
        [0x2015, '\u30fc'],
        [0xff0d, '\u30fc'],

        [0xff70, '\u002d'],
        [0x00ad, '\u002d'],
        [0x02d7, '\u002d'],
        [0x0336, '\u002d'],
        [0x05be, '\u002d'],
        [0x0c7c, '\u002d'],
        [0x1428, '\u002d'],
        [0x1806, '\u002d'],
        [0x180a, '\u002d'],
        [0x2011, '\u002d'],
        [0x2012, '\u002d'],
        [0x2013, '\u002d'],
        [0x207b, '\u002d'],
        [0x208b, '\u002d'],
    ]);
    const res = Array.from(value)
        .map((e) => {
            const key = e.charCodeAt(0);
            const val = SPECIAL_CHARACTER_MAP.get(key);
            return val ?? e;
        })
        .join('');
    return res;
};

export default unsupportedContainsValidation;
